import { render } from "./alarm-definitions.vue?vue&type=template&id=51c67d8a&ts=true"
import script from "./alarm-definitions.vue?vue&type=script&lang=ts"
export * from "./alarm-definitions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__